import { FormikProps } from "formik";
import { ChangeEvent } from "react";

export function useHandleFormActions<T>(
  setEditing: (editing: boolean) => void,
  formik: FormikProps<T>
) {
  return {
    handleSubmit() {
      setEditing(false);
      formik.handleSubmit();
    },
    handleReset() {
      setEditing(false);
      formik.resetForm();
    },
    handleEdit() {
      setEditing(true);
    }
  };
}

export function useHandleChange<T>(formik: FormikProps<T>) {
  return (name: keyof T) =>
    (event: ChangeEvent<HTMLInputElement>) =>
      formik.setFieldValue(name as string, event.target.value);
}